<form [formGroup]="fg">

	<div>
		<label>
			Buscar domicilio
			<mat-form-field [appearance]="matFormFieldAppearance">
				<input matInput #searchInput formControlName="search" placeholder="Ingresá una dirección" [errorStateMatcher]="addressSearchErrorStateMatcher">
				<form-field-lock matSuffix></form-field-lock>
				<mat-error *ngIf="fg.hasError('NotWithinCABA')">Debe estar ubicada dentro de los límites de CABA</mat-error>
				<mat-error *ngIf="fg.hasError('InvalidPlace')">Dirección inválida</mat-error>
			</mat-form-field>
		</label>
	</div>

	<mat-card class="map_wrapper margin_bottom_large" [ngClass]="{'no_shadow': matFormFieldAppearance=='fill'}">
		<div #mapDiv class="map"></div>
		<div class="error_overlay" [ngClass]="{display: (fg.hasError('NotWithinCABA') || fg.hasError('InvalidPlace')) && fcSearch.touched}"></div>
	</mat-card>

	<div>
		<label>
			Localidad
			<mat-form-field [appearance]="matFormFieldAppearance">
				<input matInput formControlName="state">
				<mat-icon matSuffix>lock</mat-icon>
			</mat-form-field>
		</label>
	</div>

	<div>
		<label>
			Código postal
			<mat-form-field [appearance]="matFormFieldAppearance">
				<input matInput formControlName="zip_code">
				<form-field-lock matSuffix></form-field-lock>
				<mat-error *ngIf="fcZipCode!.hasError('required')">Requerido</mat-error>
			</mat-form-field>
		</label>
	</div>
	
	<div>
		<label>
			Calle
			<mat-form-field [appearance]="matFormFieldAppearance">
				<input matInput formControlName="address_street">
				<mat-icon matSuffix>lock</mat-icon>
			</mat-form-field>
		</label>
	</div>

	<div>
		<label>
			Altura
			<mat-form-field [appearance]="matFormFieldAppearance">
				<input matInput formControlName="address_number">
				<mat-icon matSuffix>lock</mat-icon>
			</mat-form-field>
		</label>
	</div>

	<div class="flex_wrap gap_small">
		<div class="half_width">
			<label>
				Piso (opcional)
				<mat-form-field [appearance]="matFormFieldAppearance">
					<input matInput formControlName="address_floor" name="address_floor" inputmode="numeric">
					<form-field-lock matSuffix></form-field-lock>
					<mat-error *ngIf="fcAddressFloor!.hasError('min')">Inválido</mat-error>
					<mat-error *ngIf="fcAddressFloor!.hasError('max')">Máximo 50</mat-error>
				</mat-form-field>
			</label>
		</div>

		<div class="half_width">
			<label>
				Departamento (opcional)
				<mat-form-field [appearance]="matFormFieldAppearance">
					<input matInput formControlName="address_apartment" name="address_apartment">
					<form-field-lock matSuffix></form-field-lock>
					<mat-error *ngIf="fcAddressApartment!.hasError('min')">Inválido</mat-error>
					<mat-error *ngIf="fcAddressApartment!.hasError('max')">Máximo 50</mat-error>
				</mat-form-field>
			</label>
		</div>
	</div>

	<div>
		<label>
			Notas (opcional)
			<mat-form-field class="no_bottom_spacing" [appearance]="matFormFieldAppearance">
				<textarea matInput formControlName="extra_notes" rows="3" name="extra_notes" autocapitalize="on"></textarea>
				<form-field-lock matSuffix></form-field-lock>
				<mat-error *ngIf="fcExtraNotes!.hasError('maxlength')">Máximo 200 caracteres</mat-error>
			</mat-form-field>
		</label>
	</div>
</form>